<template>
  <div class="jade-checkbox-group">
    <span :class="computedClassLabel">
      <JadeText
        variant="text-medium"
        weight="medium"
        color="current-color"
      >
        {{ label }}
      </JadeText>
    </span>
    <div :class="computedClassCluster">
      <JadeCheckbox
        v-for="item in items"
        :key="item.label"
        :label="item.label"
        :id="item.id"
        :value.sync="item.value"
        :name="item.name"
        :disabled="disabled"
      />
    </div>
    <span :class="computedClassSupportText">
      <JadeIcon
        v-if="error"
        use="circle-alert"
        size="small"
        color="negative"
      />
      <JadeText
        variant="text-small"
        weight="regular"
        color="current-color"
      >
        {{ supportText }}
      </JadeText>
    </span>
  </div>
</template>

<script>
import JadeText from '../JadeText'
import JadeIcon from '../JadeIcon'
import JadeCheckbox from '../JadeCheckbox'
import DIRECTION_ENUM from '../enums/direction.enum'

export default {
  name: 'JadeCheckboxGroup',
  components: {
    JadeText,
    JadeIcon,
    JadeCheckbox
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    direction: {
      type: String,
      default: DIRECTION_ENUM.VERTICAL,
      validation: d => Object.values(DIRECTION_ENUM).includes(d)
    },
    label: {
      type: String,
      required: true
    },
    error: Boolean,
    disabled: Boolean,
    supportText: String
  },

  computed: {
    computedClassLabel () {
      return {
        'jade-checkbox-group__label': true,
        'is-errored': this.error,
        'is-disabled': this.disabled
      }
    },
    computedClassCluster () {
      return {
        'jade-checkbox-group__cluster': true,
        [`is-${this.direction}`]: this.direction
      }
    },
    computedClassSupportText () {
      return {
        'jade-checkbox-group__support': true,
        'is-errored': this.error,
        'is-disabled': this.disabled
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/checkbox-group.css';
</style>
